



























import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class ConfirmationDialog extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Prop() title!: string;

  @Prop() message!: string;

  @Prop() expectedText!: string;

  visible: boolean = false;

  textEntry: string = '';

  expectedTextEntered: boolean = false;

  mounted() {
    this.visible = this.value;
  }

  @Watch('visible')
  onShowChanged() {
    this.$emit('input', this.visible);
    this.textEntry = '';
  }

  @Watch('value')
  onValueChanged() {
    this.visible = this.value;
  }

  @Watch('textEntry')
  onTextEntry() {
    this.expectedTextEntered = this.textEntry.trim().toLowerCase() === this.expectedText;
  }

  onOk() {
    if (this.expectedTextEntered) {
      this.visible = false;
      this.$emit('confirmed');
    }
  }
}
